import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FurySharedModule } from 'src/@fury/fury-shared.module';
import { ListModule } from 'src/@fury/shared/list/list.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatSelectModule } from '@angular/material/select';
import { FuryCardModule } from 'src/@fury/shared/card/card.module';
import { LayoutModule } from 'src/app/layout/layout.module';
import { CoverItemAdditionalQuestionRoutingModule } from './cover-item-additional-question-routing.module';
import { CoverItemAdditionalQuestionComponent } from './cover-item-additional-question.component';
import { CoverItemListComponent } from './cover-item-list/cover-item-list.component';
import { AssignAdditionalQuestionComponent } from './assign-additional-question/assign-additional-question.component';
import { AssignClaimQuestionComponent } from './assign-claim-question/assign-claim-question.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { SubCoveredItemsListComponent } from './sub-covered-items-list/sub-covered-items-list.component';
import { AssignFirstQuestionComponent } from './assign-first-question/assign-first-question.component';

@NgModule({
  declarations: [
    CoverItemAdditionalQuestionComponent,
    CoverItemListComponent,
    AssignAdditionalQuestionComponent,
    AssignClaimQuestionComponent,
    SubCoveredItemsListComponent,
    AssignFirstQuestionComponent
  ],
  imports: [
    CommonModule,
    CoverItemAdditionalQuestionRoutingModule,
    FurySharedModule,
    ListModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    MatCheckboxModule,
    MatTableModule,
    MatPaginatorModule,
    FlexLayoutModule,
    MatIconModule,
    MatSlideToggleModule,
    NgxPaginationModule,
    MatSelectModule,
    FuryCardModule,
    LayoutModule,
    MatExpansionModule
  ]
})
export class CoverItemAdditionalQuestionModule { }
